<template>
    <span>
       {{time}}
    </span>
</template>

<script>
  import {PPComponentMixin} from "../mixins";
  import {durationToString} from "../utils";

  export default {
    name: "PPLabelDuration",
    mixins: [PPComponentMixin],
    computed: {
      time() {
        if (!this.player || this.player.duration === Number.NaN
          || this.player.duration < 0
          || this.player.duration === Infinity){
          return "--:--:--";
        }
        return durationToString(Math.round(this.player.seekRange.end))
      }

    }
  }
</script>
